import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { cssProperty } from '@holmescorp/middleware/css-property';
import css from '../css/target-viz.m.css';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
const nls = createNlsMiddleware('ditabook');
const factory = create({ nls, theme, cssProperty }).properties();
const lang = window.hcstatic.portal_language || 'en';
const num = new Intl.NumberFormat('en', { style: 'decimal', maximumSignificantDigits: 2 });
const pct = new Intl.NumberFormat(lang, { style: 'percent', maximumSignificantDigits: 2 });
export const TargetViz = factory(({ properties, middleware: { nls, theme, cssProperty } }) => {
    const { messages: { topic_progress_score = '[ditabook] topic_progress_score' } } = nls();
    const { xqa, title, percent } = properties();
    const scorePercent = cssProperty.get('root', '--score-percent');
    if (scorePercent !== num.format(percent)) {
        cssProperty.set('root', '--score-percent', num.format(percent));
    }
    const barScore = percent > 0 ? pct.format(percent) : 'NA';
    const themeCss = theme.classes(css);
    return [
        v('dt', { key: 'title', classes: [themeCss.title] }, [title]),
        v('dd', { key: 'root', classes: [themeCss.wrapper], xqa }, [
            v('div', { key: 'field', classes: [themeCss.field] }, [v('div', { key: 'bar', classes: [themeCss.bar] })]),
            v('div', { key: 'target', classes: [themeCss.target] }, ['\u23ae']),
            v('div', { key: 'bar-score', xqa: 'viz score', classes: [themeCss.barscore] }, [
                v('span', { 'aria-label': topic_progress_score }, [`${barScore}`])
            ])
        ])
    ];
});
